import { defineStore } from 'pinia'

const taskType = {
  box2d:'矩形框',
  polygon:'多边形',
  point:'点',    
  linestrip:'折线',
  tag:'筛选',
  box3d:'3D点云',
  video:'视频',
  other:'其它',
  //box3d:'3D点云',
}

const taskSatus = {
  to_be_submitted:'待提交',
  to_be_confirmed:'待确认',
  to_be_received:'待接收',
  to_be_split:'待拆分',
  rejected:'已拒绝',
  in_progress:'进行中',
  acceptance_completed:'初验完成',
  completed:'已完成',
  terminated:'已终止',
  label_completed:'标注完成'

}

const subtaskSatus = {
  to_be_assigned:'待指派',
  to_be_labeled:'待标注',
  in_labeling:'标注中',
  to_be_inspected:'待质检',
  in_inspecting:'质检中',
  inspection_failed:'质检不通过',
  to_be_submitted:'待提交',
  to_be_accepted:'待初验',
  in_accepting:'初验中',
  acceptance_completed:'初验通过',
  terminated:'已终止',
}


const fileStatus = {
  waiting_to_read_file:'等待读取文件',
  reading_file_error:'读取文件异常',
  waiting_for_unzip:'等待解压',
  unzip:'解压中',
  unzip_error:'解压异常',
  waiting_to_read_annotation_file:'等待读取标注文件',
  reading_annotation_file:'正在读取标注文件',
  reading_annotation_file_error:'读取标注文件异常',
  completed:'处理完成',
}


const fnType = {
  waiting_to_read_file:'物体检测',
  reading_file_error:'实例分割',
  waiting_for_unzip:'语义分割',
  unzip:'关键点识别',
}

const dataType = {
  waiting_to_read_file:'无序图片',
  reading_file_error:'序列图片',
  waiting_for_unzip:'视频',
  unzip:'激光点云',
  unzip2:'多传感器图片+激光',
}


export const useStore = defineStore('main', {
  state:()=>(
    {
      taskSatus,
      subtaskSatus,
      fileStatus,
      taskType,
      fnType
    }
  ),
  getters: {
    taskTypeOpt(state) {
      let arr = []
      for(let prop in state.taskType){
        arr.push({
          value:prop,
          label:state.taskType[prop]
        }) 
      }
      return arr
    },
  },
  actions:{
    getTypeName(type){
      return this.taskSatus[type]
    },
    getStateName(value){
      return this.taskSatus[value]
    },
    getSubStateName(value){
      debugger
      return this.subtaskSatus[value]
    }
  }
})